import React from "react";
import ContactHero from "../container/contactHero/ContactHero";
import ContactForm from "../container/contactForm/ContactForm";
import ContactEmail from "../container/contactEmail/ContactEmail";
// import ContactDetails from "../container/contactDetails/ContactDetails";

const ContactUs = () => {
  return (
    <>
      <ContactHero />
      <ContactForm />
      <ContactEmail />
      {/* <ContactDetails /> */}
    </>
  );
};

export default ContactUs;
